import { Dashboard } from '../../Model/Dashboard';
import { DashboardRepository } from '../Repositories/DashboardRepository';

export class GetDashboardSummaryUseCase {
  constructor(private repo: DashboardRepository) {}
  execute(): Promise<Dashboard> {
    return this.repo.getSummary().then(r => r).catch(err => Promise.reject(err));
  }
}
